/* flb-replo.js — recâblage maison de la page Replo clonée (offres, ATC, prix, accordéons, carrousels).
   Le runtime Replo d'origine n'est pas chargé : ce script fournit l'interactivité. */
(function () {
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var root = document.getElementById('replo-fullpage-element') || document;
    var V = window.FLB_VARIANTS || [];
    var LABELS = ['1 buteleczka', '2 buteleczki -25%', '3 buteleczki -33%', '6 buteleczek -40%'];
    var SEL_CLS = 'r-1b6jka9'; // classe "sélectionné" native Replo (texte blanc + ombre)
    function money(c){ return (Number(c)/100).toFixed(2).replace('.', ',') + '€'; }
    function pct(v){ if (!v.compare || v.compare <= v.price) return ''; return '-' + Math.round((1 - v.price / v.compare) * 100) + '%'; }
    var sel = 0;

    // --- Sélecteur d'offres ---
    var cards = Array.prototype.filter.call(root.querySelectorAll('[role="button"]'), function (el) {
      return LABELS.indexOf((el.textContent || '').trim()) !== -1;
    });
    function apply(){
      cards.forEach(function (el) {
        var on = LABELS.indexOf((el.textContent || '').trim()) === sel;
        el.classList.toggle('flb-sel', on);
        if (on) el.classList.add(SEL_CLS); else el.classList.remove(SEL_CLS);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var v = V[sel]; if (!v) return;
      root.querySelectorAll('[data-replo-price="true"]').forEach(function (n) { var p = n.querySelector('p'); if (p) p.textContent = money(v.price); });
      root.querySelectorAll('[data-replo-compare="true"]').forEach(function (n) { var p = n.querySelector('p'); if (p) p.textContent = v.compare ? money(v.compare) : ''; });
      root.querySelectorAll('[data-replo-compare-percentage="true"]').forEach(function (n) { var p = n.querySelector('p'); if (p) p.textContent = pct(v); });
    }
    cards.forEach(function (el) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function () { sel = LABELS.indexOf((el.textContent || '').trim()); apply(); });
    });

    // --- Ajouter au panier ---
    root.querySelectorAll('[data-replo-add-product-variant-to-cart]').forEach(function (btn) {
      btn.style.cursor = 'pointer';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var v = V[sel];
        if (!v) { window.location.href = '/cart'; return; }
        btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { window.location.href = '/cart'; });
      });
    });

    // --- Accordéons (Radix collapsible) ---
    root.querySelectorAll('[data-replo-collapsible]').forEach(function (col) {
      var head = col.querySelector('[aria-expanded]');
      var panel = null;
      if (head) { var id = head.getAttribute('aria-controls'); if (id) panel = document.getElementById(id); }
      if (!panel) panel = col.querySelector('.replo-animated');
      if (!head || !panel) return;
      function set(open){
        col.setAttribute('data-state', open ? 'open' : 'closed');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.display = open ? '' : 'none';
        panel.style.height = open ? 'auto' : '';
      }
      set(false);
      head.style.cursor = 'pointer';
      head.addEventListener('click', function () { set(head.getAttribute('aria-expanded') !== 'true'); });
    });

    // --- Carrousels (scroll-snap + flèches + dots) ---
    root.querySelectorAll('[data-replo-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-replo-part="slide-track"]');
      if (!track) return;
      track.style.display = 'flex';
      track.style.overflowX = 'auto';
      track.style.scrollSnapType = 'x mandatory';
      track.style.scrollBehavior = 'smooth';
      track.style.webkitOverflowScrolling = 'touch';
      track.style.scrollbarWidth = 'none';
      var slides = track.querySelectorAll('[data-replo-part="slide"]');
      slides.forEach(function (s) { s.style.scrollSnapAlign = 'start'; });
      car.querySelectorAll('[data-replo-part="nav-button"]').forEach(function (b) {
        b.style.cursor = 'pointer';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var dir = b.getAttribute('data-direction') === 'previous' ? -1 : 1;
          track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
        });
      });
      car.querySelectorAll('[aria-label^="Przejd"]').forEach(function (d, i) {
        d.style.cursor = 'pointer';
        d.addEventListener('click', function (e) {
          e.preventDefault();
          if (slides[i]) slides[i].scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
        });
      });
    });

    apply();
  });
})();
